/**
 * @return {string} document title
 */
export function documentTitle() {
  return document.title;
}
